<!-- 质量管理 仪表图 -->
<template>
  <div>
    <div class="circle-wrapper">
      <div class="circle-content" :id="id"></div>
      <div class="title">{{title}}</div>
      <div class="content">
        <div class="sp1" :style="percent=='无数据'?'fontSize:14px;color:#e1e1eb':''">{{percent}}</div>
        <div class="sp2">{{unit}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["color", "percent", "id", "title", "content", "unit", "name1", "name2"],
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {
    const echarts = require("echarts");
    const myChart = echarts.init(document.getElementById(this.id));
    //console.log(this.content)
    //console.log(this.percent)
    let that = this
    const option = {
      tooltip: {
          trigger: 'item',
          position:'bottom',
          // formatter: '{a} <br/>{b}: {c}' + this.unit
          formatter: function(){
            var res=option.series[0].name+'<br />';
            var myseries=option.series;
            for(var i=0;i<myseries.length;i++){
                //在内部继续循环series[i],从data中判断：当地区名称等于params.name的时候就将当前数据和名称添加到res中供显示
                for(var k=0;k<myseries[i].data.length;k++){
                    ////console.log(myseries[i].data[k].name);
                    //如果data数据中的name和地区名称一样
                    // if(myseries[i].data[k].name==params.name){
                        //将series数据系列每一项中的name和数据系列中当前地区的数据添加到res中
                        res+=myseries[i].data[k].name+':'+myseries[i].data[k].value+that.unit+'<br />';
                    // }
                }
            }
            //console.log(res)
            return res
          }
      },
      series: [
        {
          name: this.title,
          type: "gauge",
          // center: ["50%", "55%"],
          radius:'100%',
          min:0,
          max:this.content,
          axisLine:{
            lineStyle:{
              color:[
                [(this.percent=="无数据"?0:this.percent)/this.content,this.percent=="无数据"?'#e1e1eb':'#4FACFA'],
                [1,'#e1e1eb']
              ],
              width:5,
              shadowColor:'#fff',
              shadowBlur:1
            }
          },
          pointer:{show:true,width:4,},
          axisLabel:{
            textStyle:{
              fontWeight:'bolder',
              color:'transparent',
              shadowColor:'#fff',
              shadowBlur:10
            }
          },
          axisTick:{
            show:false,
            length:12,
            lineStyle:{
              color:'transparent',
              shadowColor:'#fff',
              shadowBlur:10
            }
          },
          splitLine:{
            length:20,
            lineStyle:{
              width:3,
              color:'transparent',
              shadowColor:'#fff',
              shadowBlur:10
            }
          },
          title:{
            show:false,
            textStyle:{
              fontWeight:'bolder',
              fontStyle:'italic',
              color:'#000',
              shadowColor:'#fff',
              shadowBlur:10
            }
          },
          detail:{
            show:false,
            borderColor:'#fff',
            shadowColor:'#fff',
            textStyle:{
              fontWeight:'bolder',
              fontSize:14,
              color:'#000'
            },
          },
          data: [
            {
              value: (this.percent=="无数据"?0:this.percent),
              name:"转速"
              // itemStyle: { color: this.color},
            },
          ],
          animation: false
        },
      ],
    };
    myChart.setOption(option);
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped="">
.circle-wrapper {
  position: relative;
  margin-left: 38px;
  margin-right: 28px;
  margin-top: -5px;
}
.circle-content {
  width: 100px;
  height: 100px;
}
.title {
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #222222;
  font-size: 14px;
  line-height: 2;
  text-align: center;
  margin: 10px auto 10px;
}
.content {
  position: absolute;
  width: 100%;
  top: 60px;
  // left: 28px;
  text-align: center;
  .sp1 {
    font-size: 24px;
    font-weight: bold;
  }
  .sp2 {
    margin-left: 2px;
    font-size: 12px;
  }
}
</style>